import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileManagerComponent } from "../file-manager/file-manager.component";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-gallery-selector',
  standalone: true,
  imports: [CommonModule, FileManagerComponent],
  templateUrl: './gallery-selector.component.html',
  styleUrl: './gallery-selector.component.css'
})
export class GallerySelectorComponent {
  @Input() multiselect: boolean = true;
  @Input() isParonama360: boolean = false;
  @Output() selected = new EventEmitter<string[]>();

  @ViewChild('galleryModal') galleryModal: any;

  selectedImages: string[] = [];


  constructor(private modalService: NgbModal) {}

  handleFileSelection(files: string | string[]) {
    const selected = Array.isArray(files) ? files : [files];
    this.selectedImages = Array.from(new Set([...this.selectedImages, ...selected]));
    this.selected.emit(this.selectedImages);
  }


  openGalleryModal() {
    this.modalService.open(this.galleryModal, {
      size: 'xl',
      windowClass: 'custom-filemanager-modal',
      fullscreen: true
    }).result.then(() => {
      // modal closed successfully
    }, () => {
      // modal dismissed
      this.handleFileSelection(this.selectedImages); // emit selected on close
    });
  }

  confirmSelection(modal: any) {
    this.selected.emit(this.selectedImages);
    modal.close();
  }
  
  onSelectionChanged(images: string[]) {
    this.selectedImages = images;
  }






}


 